function showAccordionB() {
    const classes = {
        block: 'm-accordion-b',
        group: 'js-accordion-b-group',
        link: 'js-accordion-b-heading-link',
        text: 'js-accordion-b-text-wrapper',
        track: 'js-accordion-b-track',
        active: 'is-active',
    };

    $('.m-accordion-b__heading-wrapper').click(function (e) {
        const group = $(e.target).closest(`.${classes.group}`);
        const text = group.find(`.${classes.text}`);
        const track = group.find(`.${classes.track}`);

        group.toggleClass(classes.active);
        track.toggleClass('rotate-45');
        // eslint-disable-next-line jquery/no-slide
        text.slideToggle(300);
    });

    /**
     * Disable scroll page to #hash on click
     * Remove Hash from URL when close Accordion
     **/
    $(`.${classes.link}`).click(function (e) {
        const group = $(e.target).closest(`.${classes.group}`);
        e.preventDefault();

        let newURL = '';
        if (group.hasClass(classes.active)) {
            const pageHashTarget = window.location.hash;
            newURL = window.location.href.replace(`${pageHashTarget}`, '');
        } else {
            newURL = e.currentTarget.href;
        }
        window.history.pushState({ path: newURL }, '', newURL);
    });

    /**
     * Open accordion if url-hash exists
     **/
    (function () {
        const anchor = location.hash
            ? document.querySelector(location.hash)
            : '';
        if (!anchor) {
            return;
        }
        if (!anchor.closest('[data-module="showAccordion"]')) {
            return;
        }

        const group = $(anchor).closest(`.${classes.group}`);
        const link = group.find(`.${classes.link}`);
        setTimeout(function () {
            link.click();
        }, 700);
    })();
}

export default showAccordionB;
